import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AbstractUserProvider } from '@skykick/platform-identity-auth-auth0-angular';

// Can be combined with HasPermissionGuard into a single guard
export const ProductAccessGuard: CanActivateFn = () => {
    const user = inject(AbstractUserProvider).getCurrentUser();
    return user.hasPermission('Migrations_Full_Access') || user.hasPermission('Cloud_Backup_Full_Access');
};